import React from 'react';
import { OFFER } from '../data/offer';
export function Footer() {
  return <footer className="w-full bg-sand border-t border-sage/20" data-id="element-93" data-mp="3gf942tsw627w">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12 text-center" data-id="element-94" data-mp="3ggk6oqalp3xf">
        <p className="font-serif font-medium text-ink text-[20px]" data-id="element-95" data-mp="32ovz90bar3ms">
          The 12-Month Wedding Plan&trade;
        </p>
        <p className="mt-3 mx-auto max-w-lg text-[16px] leading-[1.6] text-ink-soft" data-id="element-96" data-mp="36ppktn19o6ci">
          For couples who&rsquo;d rather enjoy being engaged than spend twelve
          months feeling behind.
        </p>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[14px] font-medium text-ink-soft" data-id="element-97" data-mp="36msyjwt2ysh">
          <li data-id="element-98" data-mp="3qdf4f6z1v0an">
            <a href={`mailto:${OFFER.supportEmail}`} className="transition-colors duration-150 ease-out hover:text-sage-deep" data-id="element-99" data-mp="3qd6rxg6u9wzz">
              {OFFER.supportEmail}
            </a>
          </li>
          <li data-id="element-100" data-mp="2ez1kuebbx70f">
            <a href={OFFER.instagramUrl} className="transition-colors duration-150 ease-out hover:text-sage-deep" data-id="element-101" data-mp="2ezurzge79yj3">
              Instagram
            </a>
          </li>
          <li data-id="element-102" data-mp="3gcaa3ffvofh0">
            <a href="#terms" className="transition-colors duration-150 ease-out hover:text-sage-deep" data-id="element-103" data-mp="3gctr8txpeztz">
              Terms &amp; Conditions
            </a>
          </li>
          <li data-id="element-104" data-mp="830grbvt3sxb">
            <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-sage-deep" data-id="element-105" data-mp="82icpt2wkaeu">
              Privacy Policy
            </a>
          </li>
        </ul>

        <p className="mt-8 text-[13px] text-ink-soft" data-id="element-106" data-mp="hrs8biwygb7p">
          &copy; 2026 The 12-Month Wedding Plan&trade;. All rights reserved.
        </p>
      </div>
    </footer>;
}